import React from 'react';
import { C } from '../../utils/styles';
import Icon from '../Icon';

function relDay(daysDiff) {
  if (daysDiff === 0) return 'today';
  if (daysDiff < 0) {
    const d = Math.abs(daysDiff);
    return `${d} day${d !== 1 ? 's' : ''} overdue`;
  }
  return `due in ${daysDiff} day${daysDiff !== 1 ? 's' : ''}`;
}

function Bucket({ id, icon, color, title, items, onClientClick, emptyText }) {
  return (
    <div data-testid={`followups-${id}`} style={{ marginBottom: 14 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <span style={{ width: 20, height: 20, borderRadius: '50%', background: color, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Icon name={icon} style={{ fontSize: 12 }} />
        </span>
        <span style={{ fontSize: 12, fontWeight: 700, color: C.text }}>
          {title} ({items.length})
        </span>
      </div>
      {items.length === 0 ? (
        <div style={{ fontSize: 12, color: C.textLight, padding: '4px 28px' }}>{emptyText}</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, paddingLeft: 28 }}>
          {items.slice(0, 6).map((it) => (
            <button
              key={`${it.clientId}-${it.action}`}
              type="button"
              data-testid={`followups-item-${it.clientId}`}
              onClick={() => onClientClick && onClientClick(it)}
              style={{
                display: 'flex', alignItems: 'baseline', gap: 8,
                padding: '4px 6px',
                background: 'transparent', border: 'none', borderRadius: 6,
                textAlign: 'left', cursor: 'pointer',
                fontFamily: 'inherit', fontSize: 12, color: C.textMid,
                transition: 'background 0.1s',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = C.bg; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
            >
              <span style={{ color: C.textLight }}>•</span>
              <span style={{ fontWeight: 700, color: C.text }}>{it.clientName}</span>
              <span>— {it.action}</span>
              <span style={{ color: C.textLight, marginLeft: 'auto' }}>({relDay(it.daysDiff)})</span>
            </button>
          ))}
          {items.length > 6 && (
            <div style={{ fontSize: 11, color: C.textLight, padding: '4px 6px' }}>
              +{items.length - 6} more
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default function FollowUpsCard({ buckets, onViewAllClick, onItemClick }) {
  const b = buckets || { overdue: [], today: [], thisWeek: [] };
  const total = b.overdue.length + b.today.length + b.thisWeek.length;

  return (
    <div
      data-testid="dashboard-followups"
      style={{ background: '#fff', border: `1px solid ${C.border}`, borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.03)' }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Icon name="calendar-outline" style={{ fontSize: 18, color: C.accent }} />
          <h3 style={{ fontSize: 11, fontWeight: 700, color: C.textLight, letterSpacing: '0.1em', textTransform: 'uppercase', margin: 0, fontFamily: "'JetBrains Mono', monospace" }}>
            Follow-up actions
          </h3>
        </div>
        <button
          type="button"
          data-testid="followups-view-all"
          onClick={onViewAllClick}
          style={{ fontSize: 11, fontWeight: 700, background: 'transparent', border: 'none', color: C.accent, cursor: 'pointer' }}
        >
          View all in Clients →
        </button>
      </div>

      {total === 0 ? (
        <div style={{ padding: '20px 0', textAlign: 'center', color: C.textLight, fontSize: 13 }}>
          <Icon name="checkmark-circle-outline" style={{ fontSize: 26, color: C.green, display: 'block', margin: '0 auto 6px' }} />
          No pending follow-ups. Caught up!
        </div>
      ) : (
        <>
          <Bucket id="overdue"  icon="alert-circle-outline" color="#dc2626" title="Overdue"   items={b.overdue}  onClientClick={onItemClick} emptyText="Nothing overdue." />
          <Bucket id="today"    icon="time-outline"          color="#d97706" title="Due today" items={b.today}    onClientClick={onItemClick} emptyText="Nothing due today." />
          <Bucket id="thisweek" icon="calendar-outline"      color="#059669" title="This week" items={b.thisWeek} onClientClick={onItemClick} emptyText="Nothing scheduled this week." />
        </>
      )}
    </div>
  );
}
